import { SelectOption } from '@synqo/frontend-component-library';
import { EnumPrintoutMergeStrategy } from './Generated';

export function getMergeStrategyLabel(value: EnumPrintoutMergeStrategy) {
    switch (value) {
        case EnumPrintoutMergeStrategy.Merged:
            return 'Alles kombiniert';
        case EnumPrintoutMergeStrategy.Separate:
            return 'Anhänge in eigene Datei';
        case EnumPrintoutMergeStrategy.Individual:
            return 'Nicht kombiniert';
    }
}

export const mergeStrategyOptions: SelectOption<EnumPrintoutMergeStrategy>[] = [
    {
        name: 'merged',
        label: getMergeStrategyLabel(EnumPrintoutMergeStrategy.Merged),
        value: EnumPrintoutMergeStrategy.Merged,
    },
    {
        name: 'separate',
        label: getMergeStrategyLabel(EnumPrintoutMergeStrategy.Separate),
        value: EnumPrintoutMergeStrategy.Separate,
    },
    {
        name: 'individual',
        label: getMergeStrategyLabel(EnumPrintoutMergeStrategy.Individual),
        value: EnumPrintoutMergeStrategy.Individual,
    },
];
